import { ApiErrorTypes, InterviewOrigin, InterviewStatus } from '../../types';
import { AppContext } from '../../context';
import { Redirect, useParams } from 'react-router-dom';
import ConfirmationCard from './components/ConfirmationCard';
import React, { useContext, useEffect } from 'react';
import Wrapper from '../../components/Wrapper';

import './styles.scss';

const Confirm: React.FC = () => {
    const { hash } = useParams<{ hash: string }>();
    const { meetIntro, getMeetIntro, translate } = useContext(AppContext);

    useEffect(() => {
        if (!meetIntro) {
            getMeetIntro(hash);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (meetIntro?.data?.hasError) {
        if (meetIntro?.data?.gtErrorName === ApiErrorTypes.EXPIRED_INTERVIEW) {
            return <Redirect to={`/expired/${hash}`} />;
        }
        return <Redirect to={'/invalid-link'} />;
    }
    const interviewIsPendingCandidateResponse =
        meetIntro &&
        !meetIntro?.isLoading &&
        meetIntro?.data?.interview?.status === InterviewStatus.PENDING_CANDIDATE_RESPONSE;

    if (meetIntro?.data?.interview?.origin === InterviewOrigin.SUPERDAY) {
        const path = interviewIsPendingCandidateResponse ? 'intro' : 'confirm';
        document.location.href = `/s/${path}/${hash}`;
        return null;
    }

    if (interviewIsPendingCandidateResponse) {
        return <Redirect to={`/intro/${hash}`} />;
    }

    const logo = meetIntro?.data?.organization?.logoUrl;
    const backgroundImage = meetIntro?.data?.meetBackgroundUrlList?.[2] ?? meetIntro?.data?.meetBackgroundUrlList?.[0];

    return (
        <Wrapper
            loading={meetIntro?.isLoading}
            backgroundImage={backgroundImage}
            logo={logo}
            message={translate('confirm:submitAndCalculatingAvailability')}
        >
            <ConfirmationCard
                interview={meetIntro?.data?.interview}
                recruiterEmail={meetIntro?.data?.guest?.email || ''}
                primaryColor={meetIntro?.data?.meetCompanyColor || '#6400E0'}
                textColor={meetIntro?.data?.meetFontColor || '#FFFFFF'}
                canGuestReschedule={meetIntro?.data?.canGuestReschedule || false}
                hash={hash}
            />
        </Wrapper>
    );
};

export default Confirm;
